import * as React from "react";
import classnames from "classnames";
import { Strong, Text } from "@grandvisionhq/iris-ui";
import { isDefined } from "@grandvisionhq/utils";
import { PriceTagOrIncluded } from "../../../../../PriceTagOrIncluded/components/PriceTagOrIncluded/PriceTagOrIncluded.js";
/* empty css                             */
const ConfigurationSummaryRow = ({
  label,
  labelVariant = "caption-head",
  priceTextVariant = "caption-head",
  priceSize,
  value,
  price,
  discountText,
  className,
  pricePrefix,
  step,
  "data-t": dataT
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("configuration-summary-row", className),
      "data-t": dataT || "configuration-summary-row"
    },
    /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Strong, { variant: labelVariant }, label), /* @__PURE__ */ React.createElement(Text, { variant: "caption", className: "configuration-summary-row__value" }, value)),
    isDefined(price) && /* @__PURE__ */ React.createElement(
      PriceTagOrIncluded,
      {
        ...price,
        textVariant: priceTextVariant,
        discountText,
        pricePrefix,
        size: priceSize,
        step
      }
    )
  );
};
export {
  ConfigurationSummaryRow
};
//# sourceMappingURL=ConfigurationSummaryRow.js.map
